import { useEffect, useState, useContext, useCallback } from "preact/hooks";
import axios from "axios";
import { KeycloakContext } from "../../providers/KeycloakContext";

export default function useProfile() {
  const { keycloakClient } = useContext(KeycloakContext);
  const [profile, setProfile] = useState(null);
  const [person, setPerson] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [personKeycloak, setPersonKeycloak] = useState(
    keycloakClient
  );
  const options = [
    { value: "super-admin", label: "Super Admin", text: 'Super Admin can create/change/delete flows and has the full acceess to all Verigram Console services, including developers pack.' },
    { value: "admin", label: "Admin", text: 'Admin can view transactions, buy addtional verification packs and confirm Significant Actions of Operator' },
    { value: "operator", label: "Operator", text: 'Operator can manage verifying users. Significant Actions of Operator need confirmation from a Super-Admin or an Admin' },
    // { value: "accountant", label: "Accountant", text: 'Accountant is accounting things' },
  ];  
  const [teammates, setTeammates] = useState([]);
  const fetchProfile = useCallback( async() => {
    setIsLoading(true);
    axios
      .get("/user/account/profile")
      .then((response) => {
        setProfile(response.data);
        fetchTeammates(response.data.username);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error.message);
        setIsLoading(false);
      });
  }, []);

const updateUser = (id, fullName, position, email, role, currentRole) => {
  if (!profile) {
    console.error("Profile is not yet loaded");
    return;
  }

  handleUpdateUser(
    id,
    fullName,
    position,
    email,
    role,
    currentRole,
    profile.username
  );
};

  const handleUpdateUser = useCallback( async(id, fullName, position, email, role, currentRole, groupName) => {
      let nameParts = fullName.split(" ");
      let firstName = nameParts[0];
      let lastName = nameParts.slice(1).join(" ");
      setIsLoading(true);
      
      axios
        .post("/iam/user/update", {
          id: id,
          firstName: firstName,
          lastName: lastName,
          position: position,
          email: email,
          role: role,
          currentRole: currentRole,
        })
        .then((response) => {
          fetchTeammates(groupName);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error posting data:", error);
          setIsLoading(false);
        });
  }, []);

  const fetchTeammates = useCallback( async(groupName) => {
    setIsLoading(true);
    axios
      .get("/iam/users", {
        params: {
          groupName: groupName,
        }
      })
      .then((res) => {
        setTeammates(res.data);
        findPerson();
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error.message);
        setIsLoading(false);
      });
  }, []);

  const findPerson = () => {
    const foundTeammate = teammates.find(teammate => teammate?.username === personKeycloak.idTokenParsed.email || teammate?.email === personKeycloak.idTokenParsed.email);
    if (foundTeammate && foundTeammate !== person) {
      setPerson(foundTeammate);
    }
  }

  const addUser = async(fullName, email, position, role) => {
    if (!profile) {
      console.error("Profile is not yet loaded");
      return;
    }

    return await handleAddUser(
      fullName, 
      email, 
      position, 
      role,
      profile.username
    );
  };

  const handleAddUser = async (fullName, email, position, role, groupName) => {
    let nameParts = fullName.split(" ");
    let firstName = nameParts[0];
    let lastName = nameParts.slice(1).join(" ") ?? "";

    setIsLoading(true);
    try {
      const response = await axios.post("/iam/user", {
        email: email,
        firstName: firstName,
        lastName: lastName,
        position: position,
        role: role,
        groupName: groupName,
      });
        await fetchTeammates(groupName);
        return true; 
    } catch (error) {
      return error.response?.data?.errorMessage || "An error occurred";
    } finally {
      setIsLoading(false);
    }
  };

  const deleteUser = async(id) => {
    if (!profile) {
      console.error("Profile is not yet loaded");
      return;
    }

    return await handleDeleteUser(id, profile?.username);
  };

  const handleDeleteUser = useCallback( async (id, group_name) => {
    setIsLoading(true);
    try {
      const response = await axios.delete("/iam/user", {
        data: {
          id: id,
        },
      });
      await fetchTeammates(group_name);
      setIsLoading(false);
      return true;
    } catch (error) {
        console.error("Error deleting data:", error);
        return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect( async() => {
    if(!profile){
      await fetchProfile();
    }
  }, []);

  useEffect(()=>{
    findPerson();
  }, [teammates]);

  return { person, personKeycloak, profile, isLoading, teammates, addUser, deleteUser, updateUser, options};
}
